import React from 'react'
import { SiteQueryResult } from '@graphql/queries/__generated__/site.generated'
import { Link } from 'react-router-dom'

interface FooterBlockProps {
  block: SiteQueryResult['data']['siteSettings']['site']['footerBlocks'][0]
}

const FooterBlock: React.FC<FooterBlockProps> = ({ block }) => {
  return (
    <div className='pr-24 sm:px-24 md:px-12 md:w-200 lg:w-300 max-w-full'>
      <h3 className='text-13 font-bold mb-8'>{block.name}</h3>
      <ul className='m-0 p-0 list-none'>
        {block.links.map(link => {
          const isExternal = link.linkAddress.includes('http')
          return (
            <li key={link.pk} className='mb-8 leading-6'>
              {isExternal && (
                <a href={link.linkAddress} className='no-underline hover:underline text-13' target='_blank'>
                  {link.linkText}
                </a>
              )}
              {!isExternal && (
                <Link className='no-underline hover:underline text-13' to={link.linkAddress}>
                  {link.linkText}
                </Link>
              )}
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default FooterBlock
